// Todas las keys de sesión que hay que limpiar al forzar el logout. JWTContext.logout()
// hoy solo limpia 3 (accessToken/user/icn); un usuario impersonando además tiene las dos
// keys de impersonación, que también hay que borrar para no dejar sesión residual.
const AUTH_STORAGE_KEYS = [
  'accessToken',
  'user',
  'icn',
  'impersonatorToken',
  'impersonatorUser',
] as const;

// Rutas públicas de auth donde un usuario deslogueado se sienta legítimamente: no
// redirigir desde acá evita loops (ya estamos en /login) y no interrumpe un flujo de
// activación / cambio de contraseña.
const PUBLIC_AUTH_PATHS = ['/login', '/change-password', '/activate-user'];

// Guard de re-entrada a nivel de módulo: un batch de N requests puede disparar N errores
// de auth; queremos un solo redirect, no N.
let loggingOut = false;

/**
 * Fuerza el cierre de sesión ante un rechazo de auth del backend (usuario desactivado
 * o token inválido). Limpia todas las keys de sesión y recarga la app en /login.
 *
 * El full reload (window.location.replace) reconstruye el Apollo client desde cero
 * — cache limpio, WS link recreado sin token — y reinicia el AuthProvider en estado
 * desautenticado. Así resolvemos logout + reset de cache + cierre del WS + redirect de
 * una sola vez, sin pelear con que el errorLink vive fuera del árbol de React (no puede
 * llamar hooks ni al logout del contexto).
 *
 * No importa nada de src/graphql ni de src/contexts: el eventEmitter de esos módulos
 * importa `client` de src/graphql, y este archivo es consumido por src/graphql/index.ts
 * → un import de vuelta crearía un ciclo.
 */
export const forceLogout = (): void => {
  if (loggingOut) return;
  loggingOut = true;

  AUTH_STORAGE_KEYS.forEach((key) => window.localStorage.removeItem(key));

  const onPublicAuthPath = PUBLIC_AUTH_PATHS.some((path) =>
    window.location.pathname.startsWith(path),
  );

  if (onPublicAuthPath) {
    // No hay redirect que dispare la reconstrucción del client; liberamos el guard
    // para no bloquear intentos futuros.
    loggingOut = false;
    return;
  }

  window.location.replace('/login');
};
